import { useEffect } from "react";
import { useCheckout } from "../context/CheckoutContext";
import { safeRedirect } from "../utils/redirectUrlBuilder";

/**
 * Restores an in-flight pending CIT (PIX QR, UPI redirect, etc.) after a hosted
 * checkout page reload when the backend returns {@code pending_payment} on the session.
 */
export default function useResumePendingPayment({
  paymentMethod,
  platform,
  onResumePix,
  onResumeRedirect,
  consumed = false,
}) {
  const { pendingPaymentResume, setPendingPaymentResume } = useCheckout();

  useEffect(() => {
    if (consumed || !pendingPaymentResume || !paymentMethod || !platform) {
      return;
    }

    const resumeMethod = String(pendingPaymentResume.paymentMethod || "").toLowerCase();
    const resumePlatform = String(pendingPaymentResume.platform || "").toLowerCase();
    if (resumeMethod !== String(paymentMethod).toLowerCase()) return;
    if (resumePlatform !== String(platform).toLowerCase()) return;

    const paymentResponse = pendingPaymentResume.paymentResponse;
    if (!paymentResponse) return;

    setPendingPaymentResume(null);

    if (paymentResponse.qrCodeUrl && onResumePix) {
      onResumePix(paymentResponse, pendingPaymentResume.transactionId);
      return;
    }

    const redirectUrl = paymentResponse.redirect_url;
    if (redirectUrl && onResumeRedirect) {
      onResumeRedirect(redirectUrl, pendingPaymentResume.transactionId);
    } else if (redirectUrl) {
      safeRedirect(redirectUrl, { target: "self" });
    }
  }, [
    consumed,
    pendingPaymentResume,
    paymentMethod,
    platform,
    onResumePix,
    onResumeRedirect,
    setPendingPaymentResume,
  ]);
}
